import i18next from 'i18next';

import { JobInfoViewActionButton } from 'types/jobs';

import { AlertType, PaymentStatus } from 'constants/enums';
import { DEFAULT_JOBS_INFO_VIEW_ALERT_SETTINGS } from 'constants/jobsSettings';

import { getJobInfoViewActionButtons } from '../utils/getJobInfoViewActionButtons';

export type JobInfoViewPaymentStatusConfig = {
  alertType: AlertType;
  alertText: string;
  alertButton: JobInfoViewActionButton | null;
  actionButton: JobInfoViewActionButton | null;
};

type getJobInfoViewConfigParams = {
  onReactivate: () => void;
  onRetryPayment: () => void;
  onUpdatePayment: () => void;
  onCloseJob: () => void;
};

export const getJobInfoViewConfig = ({
  onReactivate,
  onRetryPayment,
  onUpdatePayment,
  onCloseJob
}: getJobInfoViewConfigParams): Record<
  PaymentStatus,
  JobInfoViewPaymentStatusConfig
> => {
  const {
    retryPaymentButton,
    reactivateButton,
    updatePaymentButton,
    closeJobButton
  } = getJobInfoViewActionButtons({
    onReactivate,
    onRetryPayment,
    onUpdatePayment,
    onCloseJob
  });

  return {
    [PaymentStatus.Active]: {
      ...DEFAULT_JOBS_INFO_VIEW_ALERT_SETTINGS,
      actionButton: closeJobButton
    },
    [PaymentStatus.Canceled]: {
      alertType: AlertType.Info,
      alertText: i18next.t('sidebar.job.alert.paymentCanceled'),
      alertButton: reactivateButton,
      actionButton: reactivateButton
    },
    [PaymentStatus.Unpaid]: {
      ...DEFAULT_JOBS_INFO_VIEW_ALERT_SETTINGS
    },
    [PaymentStatus.Incomplete]: {
      ...DEFAULT_JOBS_INFO_VIEW_ALERT_SETTINGS,
      actionButton: retryPaymentButton
    },
    [PaymentStatus.PastDue]: {
      alertType: AlertType.Error,
      alertText: i18next.t('sidebar.job.alert.paymentPastDue'),
      alertButton: updatePaymentButton,
      actionButton: updatePaymentButton
    },
    [PaymentStatus.Expired]: {
      ...DEFAULT_JOBS_INFO_VIEW_ALERT_SETTINGS,
      actionButton: retryPaymentButton
    },
    [PaymentStatus.IncompleteExpired]: {
      alertType: AlertType.Error,
      alertText: i18next.t('sidebar.job.alert.paymentIncomplete'),
      alertButton: updatePaymentButton,
      actionButton: updatePaymentButton
    },
    [PaymentStatus.Paused]: {
      ...DEFAULT_JOBS_INFO_VIEW_ALERT_SETTINGS
    },
    [PaymentStatus.Trialing]: {
      ...DEFAULT_JOBS_INFO_VIEW_ALERT_SETTINGS
    }
  };
};
